import { useReviewTime } from "@/hooks/useReviewTime";
import { api } from "@convex/_generated/api";
import { useQuery } from "convex/react";

export function useAllDecks() {
  const reviewTime = useReviewTime();
  const decks = useQuery(api.decks.getAll, { reviewTime });
  return decks;
}
